import { render } from "./Start.vue?vue&type=template&id=76b03eca&ts=true&lang=pug"
import script from "./Start.vue?vue&type=script&lang=ts"
export * from "./Start.vue?vue&type=script&lang=ts"

import "./Start.vue?vue&type=style&index=0&id=76b03eca&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__